import { Component, ElementRef, inject } from '@angular/core';

import { AppMaterialModule } from '../../material.module';
import { SharedModule } from '../../shared.module';
import { LoadingPageService } from 'src/app/infrastructure/services/loading-services/loading-page.service';
import { _ImageBoxComponent } from '../abstract-classes/_image-box.component';

@Component({
    selector: 'app-image-box',
    templateUrl: './image-box.component.html',
    standalone: true,
    imports: [
        AppMaterialModule,
        SharedModule,
    ],
    styleUrls: [
        '../image-box.scss',
        './image-box.component.scss']
})
export class ImageBoxComponent
    extends _ImageBoxComponent
{
    protected override _loadingPageService = inject(LoadingPageService);

    private readonly __elementRef = inject(ElementRef<HTMLElement>);

    override border$$ = this.input_border$$;
    override guid$$ = this.input_guid$$;
    override guidPath$$ = this._guidPath$$;
    override hideOnLoading$$ = this.input_hideOnLoading$$;
    override loading$$ = this._loading$$;
    override size$$ = this.input_size$$;
    override tooltip$$ = this.input_tooltip$$;
    override tooltipPosition$$ = this.input_tooltipPosition$$;
    override url$$ = this.input_url$$;
    override version$$ = this.input_version$$;

    // Zet de werkelijke breedte/hoogte-verhouding als CSS-variabele (getal,
    // bruikbaar in calc()) op de host, zodat consumers (bv. het login-logo)
    // op basis van de échte verhouding een min-height-bodem kunnen berekenen
    // zonder de afbeelding te vervormen.
    onImgLoad(event: Event): void {
        const __img = event.target as HTMLImageElement;

        if (__img.naturalWidth && __img.naturalHeight) {
            this.__elementRef.nativeElement.style.setProperty('--image-ratio', `${__img.naturalWidth / __img.naturalHeight}`);
        }
    }
}
